import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logInUser} from '../../actions/user';
import LoginForm from '../../components/login-form';
import style from './style.css';
import { Redirect } from 'react-router-dom';

class Login extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
    };

    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onUsernameChange = this.onUsernameChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/redigera' } };
    const { username, password } = this.state;
    const { user } = this.props;

    if (user.sessionToken) {
      return <Redirect to={ from }/>;
    }

    return (
      <main>
        <section className={ style.section }>
          <h1 className={ style.title }>Logga in</h1>
          <LoginForm username={ username}
            password={ password }
            isFetching={ user.isFetching }
            onPasswordChange={ this.onPasswordChange }
            onUsernameChange={ this.onUsernameChange }
            onSubmit={ this.onSubmit }/>
        </section>
      </main>
    );
  }

  onPasswordChange(event) {
    const password = event.target.value;
    this.setState({ password });
  }

  onUsernameChange(event) {
    const username = event.target.value;
    this.setState({ username });
  }

  onSubmit(event) {
    event.preventDefault();

    const { username, password } = this.state;
    const { dispatch } = this.props;

    dispatch(logInUser(username, password));
  }
}

Login.propTypes = {
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};


export default connect(mapStateToProps)(Login);




// WEBPACK FOOTER //
// ./client/src/containers/login/index.js